var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.toggleMainMenu}},[_c('v-icon',[_vm._v("mdi mdi-menu")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }